module.exports = __webpack_public_path__ + "img/kid5.cd7a7fa0.png";